import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import EditChatMobileContainer from "@/components/chat/chatContainer/EditChatMobileContainer/EditChatMobileContainer.vue";
import { ChatTypes } from "@/store/chats/types";
import { chatTypeInjectionKey } from "@/utils/chat/chatTypeInjectionKey";
import { provide } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditChatMobileGroupChat',
  setup(__props) {

provide(chatTypeInjectionKey, {
  type: ChatTypes.GROUP_CHAT,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EditChatMobileContainer))
}
}

})